import { LanguageStrings } from './base-strings';

export const fr: LanguageStrings = {
  /** Routes */
  'routes.home': '/',
  'routes.summary': '/sommaire',

  /** Page content */
  'home.title': 'Accueil',
  'home.content': 'Merci de visiter cet exemple de routage multilingue.',

  'summary.title': 'Sommaire',
  'summary.content':
    "En savoir plus sur l'article lui-même sur {medium} ou {devto}.",

  'error.title': 'Erreur',
  'error.content':
    'Cette page a décidé de prendre des vacances. Réessayez plus tard.',

  /** Links */
  'links.medium':
    'https://medium.com/prototyped/multi-language-routing-in-react-d7eb7a0688e9',
  'links.dev.to': 'https://dev.to/prototyp/multi-language-routing-in-react-k9l'
};
